<template>
  <v-text-field
    ref="autocomplete"
    type="text"
    :id="id"
    :placeholder="placeholder"
    v-model="address"
    @focus="onFocus()"
    @blur="onBlur()"
    @change="onChange"
    @keypress="onKeyPress"
    @keyup="onKeyUp"
    outlined
    hide-details="auto"
    append-icon="fas fa-map-marked-alt"
    :rules="rules"
    clearable
    :disabled="disabled"
  />
</template>
<script>
const ADDRESS_COMPONENTS = {
  street_number: { from: "short_name", to: "number" },
  route: { from: "long_name", to: "street" },
  sublocality_level_1: { from: "long_name", to: "neighborhood" },
  administrative_area_level_1: { from: "short_name", to: "state" },
  administrative_area_level_2: { from: "long_name", to: "city" },
  country: { from: "long_name", to: "country" },
  postal_code: { from: "short_name", to: "postalCode" }
};

// const CITIES_TYPE = ["locality", "administrative_area_level_3"];
// const REGIONS_TYPE = [
//   "locality",
//   "sublocality",
//   "postal_code",
//   "country",
//   "administrative_area_level_1",
//   "administrative_area_level_2"
// ];

export default {
  name: "VueGoogleAutocomplete",

  props: {
    id: {
      type: String,
      required: true
    },

    placeholder: {
      type: String,
      default: "Buscar endereço - Google Maps"
    },

    types: {
      type: String,
      default: "address"
    },

    country: {
      type: [String, Array],
      default: "br"
    },

    rules: null,

    disabled: {
      type: Boolean,
      default: false
    },

    value: null
  },

  data() {
    return {
      autocomplete: null,
      autocompleteText: "",
      geolocation: {
        geocoder: null,
        loc: null,
        position: null
      },
      currentAddress: null
    };
  },

  watch: {
    autocompleteText: function(newVal, oldVal) {
      this.$emit("inputChange", { newVal, oldVal }, this.id);
    },
    country: function() {
      this.autocomplete.setComponentRestrictions({
        country: this.country === null ? [] : this.country
      });
    },
    value() {
      this.address = this.value;
    }
  },

  computed: {
    address: {
      get() {
        return this.currentAddress;
      },
      set(val) {
        this.currentAddress = val;
        this.$emit("input", this.currentAddress);
      }
    }
  },

  mounted: function() {
    this.currentAddress = this.value;
    const options = {};

    if (this.types) {
      options.types = [this.types];
    }

    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }

    this.autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById(this.id),
      options
    );

    this.autocomplete.addListener("place_changed", this.onPlaceChanged);
  },

  methods: {
    onPlaceChanged() {
      let place = this.autocomplete.getPlace();

      if (!place.geometry) {
        this.$emit("no-results-found", place, this.id);
        return;
      }

      if (place.address_components !== undefined) {
        this.$emit("placechanged", this.formatResult(place), place, this.id);
        this.autocompleteText = document.getElementById(this.id).value;
        this.address = this.autocompleteText;
        this.onChange();
      }
    },

    formatResult(place) {
      let returnData = {};
      for (let i = 0; i < place.address_components.length; i++) {
        for (let j = 0; j < place.address_components[i].types.length; j++) {
          let addressType = place.address_components[i].types[j];
          if (ADDRESS_COMPONENTS[addressType]) {
            let val =
              place.address_components[i][ADDRESS_COMPONENTS[addressType].from];
            returnData[ADDRESS_COMPONENTS[addressType].to] = val;
            break;
          }
        }
      }

      returnData["latitude"] = place.geometry.location.lat();
      returnData["longitude"] = place.geometry.location.lng();
      return returnData;
    },

    onFocus() {
      //this.biasAutocompleteLocation();
      this.$emit("focus");
    },

    onBlur() {
      this.$emit("blur");
    },

    onChange() {
      this.$emit("change", this.autocompleteText);
    },

    onKeyPress(event) {
      this.$emit("keypress", event);
    },

    onKeyUp(event) {
      this.$emit("keyup", event);
    },

    clear() {
      this.autocompleteText = "";
    },

    focus() {
      this.$refs.autocomplete.focus();
    },

    blur() {
      this.$refs.autocomplete.blur();
    },

    update(value) {
      this.autocompleteText = value;
    }

    /*updateCoordinates(value, position) {
      if ((!value && !(value.lat || value.lng)) || !position) return;
      if (!this.geolocation.geocoder)
        this.geolocation.geocoder = new window.google.maps.Geocoder();
      this.geolocation.geocoder.geocode(
        { location: value },
        (results, status) => {
          if (status === "OK") {
            results = this.filterGeocodeResultTypes(results);
            if (results[0]) {
              this.$emit(
                "placechanged",
                this.formatResult(results[0]),
                results[0],
                this.id
              );
              this.update(results[0].formatted_address);
            } else {
              this.$emit("error", "no result for provided coordinates");
            }
          } else {
            this.$emit("error", "error getting address from coords");
          }
        }
      );
    },

    updateGeolocation(callback = null) {
      if (navigator.geolocation) {
        let options = {};
        if (this.geolocationOptions)
          Object.assign(options, this.geolocationOptions);
        navigator.geolocation.getCurrentPosition(
          position => {
            let geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            this.geolocation.loc = geolocation;
            this.geolocation.position = position;

            if (callback) callback(geolocation, position);
          },
          err => {
            this.$emit("error", "Cannot get Coordinates from navigator", err);
          },
          options
        );
      }
    },

    biasAutocompleteLocation() {
      if (this.enableGeolocation) {
        this.updateGeolocation((geolocation, position) => {
          let circle = new window.google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },

    

    filterGeocodeResultTypes(results) {
      if (!results || !this.types) return results;
      let output = [];
      let types = [this.types];
      if (types.includes("(cities)")) types = types.concat(CITIES_TYPE);
      if (types.includes("(regions)")) types = types.concat(REGIONS_TYPE);

      for (let r of results) {
        for (let t of r.types) {
          if (types.includes(t)) {
            output.push(r);
            break;
          }
        }
      }
      return output;
    }*/
  }
};
</script>
